var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"my-0 text-none",attrs:{"color":_vm.color,"disabled":_vm.disabled},domProps:{"innerHTML":_vm._s(_vm.btnText)},on:{"touchstart":_vm.attack,"touchend":_vm.release,"mousedown":_vm.attack,"mouseup":_vm.release}})}
var staticRenderFns = []

export { render, staticRenderFns }